import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Alert_Interface } from 'src/app/Interface/Alert_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private http: HttpClient) { }

  GetRecord(startDate: String, endDate: String): Observable<Array<Alert_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Alert?startDate=" + startDate
    + "&endDate=" + endDate).pipe(
      map(data => {
        return data as Array<Alert_Interface>
      })
    )
  }

  GetInbox(startDate: String, endDate: String): Observable<Array<Alert_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Alert/GetInbox?startDate=" + startDate
    + "&endDate=" + endDate).pipe(
      map(data => {
        return data as Array<Alert_Interface>
      })
    )
  }

  GetActive(): Observable<Array<Alert_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Alert/GetActive").pipe(
      map(data => {
        return data as Array<Alert_Interface>
      })
    )
  }

  SubmitAlert(id:number,
    message: string, 
    cutomer: boolean, 
    title: String,
    expireDate: String,
    chart_id: Array<number>,
    file: Array<string>): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var model = {
      id: id,
      title: title,
      cutomer: cutomer,
      message: message,
      create_username: expireDate,
    }

    var body = {
      model: model,
      files: file,
      chart_id: chart_id
    }


    return this.http.post(environment.BaseUrl + "Daro/Alert/SubmitAlert", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  uploadFile(body) {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Alert/Upload", body).pipe(
      map(data => {

        return data
      })
    )
  }

  DeleteAlert(id: number): Observable<Alert_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Alert/Delete?id=" + id ).pipe(
      map(data => {
        return data as Alert_Interface
      })
    )

  }

}
